import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./HomeScreen.module.css";
import MainFooter from "../../components/MainFooter/MainFooter";
import { getHomeScreenBooks } from "../Books/BooksActions";
import { getAuthors } from "../Users/UsersActions";
import StarAuthors from "./StarAuthors/StarAuthors";
import HeroSection from "./HeroSection/HeroSection";
import EditorsChoice from "./EditorsChoice/EditorsChoice";
import B2BInfo from "./B2BInfo/B2BInfo";
import SeoBanner from "./SeoBanner/SeoBanner";
import WelcomeModal from "../../components/Header/WelcomeModal/WelcomeModal";
import Testimonials from "./Testimonials/Testimonials";
import ThemesContainer from "./ThemesContainer/ThemesContainer";
import CreativeContainer from "./CreativeContainer/CreativeContainer";
import WebTraffic from "../../components/WebTraffic/WebTraffic";

function HomeScreen() {
  const ratedBooks = useSelector((state) => state.books.homeScreenBooks) || [];
  const dispatch = useDispatch();
  const starAuthors = useSelector((state) => state.user.starAuthors);

  useEffect(() => {
    if (!ratedBooks.length) {
      getHomeScreenBooks(dispatch, `overallRating DESC`);
    }
    getAuthors(dispatch);
  }, [dispatch, ratedBooks.length]);

  return (
    <div className={classes.mainContainer}>
      <WebTraffic />
      <WelcomeModal />
      <HeroSection />
      <CreativeContainer />
      <EditorsChoice />
      <SeoBanner />
      {/* themes section */}
      <ThemesContainer />
      <B2BInfo />
      <StarAuthors authors={starAuthors} />
      <Testimonials />
      <MainFooter />
    </div>
  );
}

export default HomeScreen;
